<template>
  <nav id="breadcrumbs" class="company-breadcrumb" :aria-label="ariaLabel">
    <ul>
      <li>
        <router-link :to="homeRoute" :aria-label="homeAriaLabel">
          <i :class="homeIcon" aria-hidden="true"></i>
        </router-link>
      </li>
      <li
        v-for="(item, index) in items"
        :key="`${item.name}_${index}`"
        :aria-current="index === items.length - 1 ? 'page' : null"
      >
        <router-link v-if="item.route" :to="item.route">
          {{ item.name }}
        </router-link>
        <span v-else>{{ item.name }}</span>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: "CompanyBreadcrumb",
  props: {
    items: {
      type: Array,
      required: true,
    },
    ariaLabel: {
      type: String,
      required: true,
    },
    homeAriaLabel: {
      type: String,
      required: true,
    },
    homeRoute: {
      type: [Object, String],
      default: () => ({ name: "company.dashboard" }),
    },
    homeIcon: {
      type: String,
      default: "uil-home-alt",
    },
  },
};
</script>

<style scoped>
.company-breadcrumb {
  margin-bottom: 24px;
}

.company-breadcrumb ul {
  display: flex;
  align-items: center;
  min-height: 32px;
  margin: 0;
  padding: 0;
}

/* Global `#breadcrumbs` (style.scss) id ile geliyor: `margin: 4px 0 0 0` ve
   640px altinda `display: none`. Class secici (0,2,0) id'yi (1,0,0) ezemez,
   bu yuzden asagidaki yerlesim kurallari id ile niteleniyor. */
@media (max-width: 767px) {
  #breadcrumbs.company-breadcrumb {
    display: block;
    overflow-x: auto;
    margin: 0 0 8px;
    padding: 0;
    scrollbar-width: none;
  }

  .company-breadcrumb::-webkit-scrollbar {
    display: none;
  }

  .company-breadcrumb ul {
    width: max-content;
  }
}
</style>
